// FormContext.js
import React, { createContext, useContext, useState } from "react";

const FormContext = createContext();

export const useFormContext = () => useContext(FormContext);

export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    propertyBasic: {
      categoryId: "",
      name: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      pin: "",
      latitude: null,
      longitude: null,
    },
    propertyDetails: {}, // 나중에 실제로 쓰는 필드 생기면 그때 추가
  });

  return (
    <FormContext.Provider value={{ formData, setFormData }}>
      {children}
    </FormContext.Provider>
  );
};